module.exports = __webpack_public_path__ + "static/media/ProductView Intro.70b1ed8a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/ProductView Intro.svg
// module id = 639
// module chunks = 0